<template>
  <v-card class="card-container">
    <v-dialog v-model="dialog" max-width="900px">
      <ManageSupplier
        title="Novo Fornecedor"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este fornecedor?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteManyDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t(
                'Tem certeza de que deseja excluir os fornecedores selecionados?'
              )
            }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteManyDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="removeMany"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="editDialog" max-width="900px">
      <ManageSupplier
        title="Editar fornecedor"
        :supplier="currentSupplier"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="aboutDialog" max-width="900">
      <AboutSupplier :receivedSupplier="currentSupplier" :key="dialogKey" />
    </v-dialog>

    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-img
          src="../../../../assets/figmaIcons/white/supplier.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">{{ $t('Fornecedores') }}</span>

      <v-spacer></v-spacer>

      <v-btn dark class="terciary-button mr-2" depressed @click="exportToExcel">
        {{ $t('Exportar para excel') }}
      </v-btn>

      <v-btn
        v-show="userType < 4 || userType == 8 || userType >= 7"
        dark
        class="terciary-button mr-4"
        depressed
        @click="openImportWindow"
      >
        {{ $t('Importar fornecedores') }}
      </v-btn>

      <v-btn
        v-show="userType < 4 || userType == 8 || userType >= 7"
        color="#0F3565"
        depressed
        class="hidden-sm-and-down mr-0 mb-0 secondary-button"
        @click="addSupplier"
      >
        {{ $t('Novo fornecedor') }}
      </v-btn>

      <v-btn
        v-show="buttonDeleteVisible"
        v-if="userType < 3 || userType == 8"
        class="ml-3 hidden-sm-and-down quaternary-button"
        color="#A42A2AD9"
        dark
        depressed
        @click="deleteManySuppliers"
      >
        {{ $t('Remover selecionados') }}
      </v-btn>
      <v-btn
        class="ml-3 hidden-sm-and-down primary-button"
        color="#BBCF20"
        dark
        depressed
        @click="visible = !visible"
      >
        Filtros
      </v-btn>
    </div>

    <div flat class="my-5 hidden-md-and-up">
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          dark
          small
          class="terciary-button mr-2 mb-1"
          depressed
          @click="exportToExcel"
        >
          <v-icon color="white">mdi-file-excel</v-icon>
        </v-btn>

        <v-btn
          v-show="userType < 4 || userType == 8 || userType >= 7"
          dark
          small
          class="terciary-button mr-2 mb-1"
          depressed
          @click="openImportWindow"
        >
          <v-icon color="white">mdi-upload</v-icon>
        </v-btn>

        <v-btn
          v-show="userType < 4 || userType == 8 || userType >= 7"
          small
          class="hidden-md-and-up mr-2 mb-1"
          color="#0F3565"
          depressed
          @click="addSupplier"
        >
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>

        <v-btn
          v-show="buttonDeleteVisible"
          v-if="userType < 3 || userType == 8"
          small
          class="hidden-md-and-up mr-2 mb-1"
          color="#A42A2AD9"
          depressed
          dark
          @click="deleteManySuppliers"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>

        <v-btn
          class="hidden-md-and-up mb-1"
          small
          color="#BBCF20"
          depressed
          dark
          @click="visible = !visible"
        >
          <v-icon> mdi-filter </v-icon>
        </v-btn>
      </div>
    </div>

    <v-expand-transition>
      <div v-show="visible">
        <v-row class="ma-0" dense>
          <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
            <label class="label">{{ $t('Instituição') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="institutionId"
              :items="institutions"
              item-value="id"
              item-text="name"
              :loading="institutionLoading"
              outlined
              disabled
              class="primary-input"
              append-icon=""
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
            <label class="label">{{ $t('Fornecedor') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="supplierName"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">{{ $t('Razão social') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="supplierCorporateName"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">{{ $t('CPF') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="supplierCpf"
              v-mask="['###.###.###-##']"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">{{ $t('CNPJ') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="supplierCnpj"
              v-mask="['##.###.###/####-##']"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="3" lg="3">
            <label class="label">{{ $t('Contato técnico') }}</label>
            <v-text-field
              hide-details="auto"
              :v-model="supplierTechnicalContact"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="3" lg="3">
            <label class="label">{{ $t('Estado') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="supplierState"
              :items="states"
              @change="getCities"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="3" lg="3">
            <label class="label">{{ $t('Cidade') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="supplierCity"
              no-data-text="Selecione um estado"
              :items="cities"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="3" lg="3">
            <label class="label">{{ $t('Status') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="supplierStatus"
              :items="status"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn
              class="mx-2 secondary-button"
              color="#BBCF20"
              @click="filterTable"
              depressed
            >
              <span>Filtrar</span>
              <v-icon class="pl-2">mdi-magnify</v-icon>
            </v-btn>

            <v-btn
              depressed
              color="#20202066"
              class="clear-button mr-0"
              @click="reset"
            >
              <span>{{ $t('Limpar') }}</span>
              <v-icon class="pl-2">mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <p class="mb-0" style="font-size: 0.9rem">
      *{{ $t('Exibindo fornecedores') }} <strong>{{ $t('ATIVOS') }}</strong
      >,{{ $t(" para visualização de inativos utilize o filtro 'Status'") }}
    </p>

    <div class="wrapper mobile">
      <v-data-table
        :loading="loading"
        :headers="headersMobile"
        :items="suppliers"
        v-model="suppliersSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        :items-per-page="pageSize"
        :header-props="headerProps"
        :mobile-breakpoint="0"
        :single-expand="false"
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template #[`item.name`]="{ item }">
          <a @click.stop="editSupplier(item)">{{
            item.name != null ? item.name : $t('Sem registro')
          }}</a>
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                x-small
                color="#f5f5f5"
                dark
                @click.stop="openAbout(item)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon small color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>Detalhar</span>
          </v-tooltip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>Contato técnico:</strong>
                {{
                  item.technicalContact != ''
                    ? item.technicalContact
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>E-mail técnico:</strong>
                {{
                  item.technicalEmail != ''
                    ? item.technicalEmail
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>Celular técnico:</strong>
                {{
                  item.technicalCellPhoneNumber != ''
                    ? item.technicalCellPhoneNumber
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>UF:</strong>
                {{ item.state != '' ? item.state : $t('Sem registro') }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>Ações: </strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-show="userType < 4 || userType == 8"
                      class="ma-1"
                      color="#0F3565"
                      dark
                      @click="editSupplier(item)"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      depressed
                    >
                      <v-icon small dark> mdi-pencil-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="userType < 3 || userType == 8"
                      class="ma-1"
                      x-small
                      color="#A42A2AD9"
                      style="font-weight: bold"
                      dark
                      v-bind="attrs"
                      @click="deleteSupplier(item)"
                      v-on="on"
                      depressed
                    >
                      <v-icon small color="white">
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>

      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>Selecionados: {{ suppliersSelected.length }}</span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="9"
          ></v-pagination>
        </div>
      </div>
    </div>

    <div class="wrapper desktop">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="suppliers"
        v-model="suppliersSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        hide-default-header
        :header-props="headerProps"
        :items-per-page="pageSize"
        @click:row="editSupplier"
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.name`]="{ item }">
          {{ item.name != '' ? item.name : $t('Sem registro') }}
        </template>

        <template #[`item.technicalContact`]="{ item }">
          {{
            item.technicalContact != ''
              ? item.technicalContact
              : $t('Sem registro')
          }}
        </template>

        <template #[`item.technicalEmail`]="{ item }">
          {{
            item.technicalEmail != '' ? item.technicalEmail : $t('Sem registro')
          }}
        </template>

        <template #[`item.technicalCellPhoneNumber`]="{ item }">
          {{
            item.technicalCellPhoneNumber != ''
              ? item.technicalCellPhoneNumber
              : $t('Sem registro')
          }}
        </template>

        <template #[`item.state`]="{ item }">
          {{ item.state != '' ? item.state : $t('Sem registro') }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#f5f5f5"
                dark
                @click.stop="openAbout(item)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Detalhar') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="userType < 4 || userType == 8"
                class="ma-1"
                color="#0F3565"
                dark
                @click.stop="editSupplier(item)"
                v-bind="attrs"
                v-on="on"
                small
                depressed
              >
                <v-icon dark small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Editar') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="userType < 3 || userType == 8"
                class="ma-1"
                small
                color="#A42A2AD9"
                style="font-weight: bold"
                dark
                v-bind="attrs"
                @click.stop="deleteSupplier(item)"
                v-on="on"
                depressed
              >
                <v-icon color="white"> mdi-trash-can-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Excluir') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>Selecionados: {{ suppliersSelected.length }}</span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="9"
          ></v-pagination>
        </div>
      </div>
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
a {
  color: black !important;
}

th:first-of-type {
  background-color: #e7eaeb;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import AboutSupplier from './AboutSupplier.vue'
import ManageSupplier from './ManageSupplier.vue'

export default {
  data: () => ({
    totalItensOnPage: 0,
    errorMessage: '',
    visible: false,
    dialog: false,
    editDialog: false,
    aboutDialog: false,
    importDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    buttonDeleteVisible: false,
    filterDialog: false,
    dialogKey: false,
    loading: false,
    error: false,
    institutionLoading: false,
    statesLoading: false,
    citiesLoading: false,
    institutionId: null,
    institutions: [],
    expanded: [],
    suppliersSelected: [],
    suppliers: [],
    currentSupplier: {},
    states: [],
    currentState: {},
    cities: [],
    currentCity: {},
    userType: null,
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      cnpj: null,
      cpf: null,
      corporateName: null,
      technicalContact: null,
      city: null,
      state: null,
      institutionId: null,
      status: null,
    },
    supplierName: null,
    supplierCorporateName: null,
    supplierCnpj: null,
    supplierCpf: null,
    supplierBusinessContact: null,
    supplierBusinessEmail: null,
    supplierBusinessPhoneNumber: null,
    supplierBusinessCellPhoneNumber: null,
    supplierTechnicalContact: null,
    supplierTechnicalEmail: null,
    supplierTechnicalCellPhoneNumber: null,
    supplierCity: null,
    supplierState: null,
    supplierStatus: null,
    status: ['Ativo', 'Inativo'],
    headers: [
      {
        text: 'Fornecedor',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Contato técnico',
        align: 'center',
        value: 'technicalContact',
        sortable: false,
      },
      {
        text: 'E-mail',
        align: 'center',
        value: 'technicalEmail',
        sortable: false,
      },
      {
        text: 'Celular',
        align: 'center',
        value: 'technicalCellPhoneNumber',
        sortable: false,
      },
      {
        text: 'UF',
        align: 'center',
        value: 'state',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Fornecedor',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  async created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getInstitutions()
    this.getStates()
    this.updateTable()
  },

  components: {
    ManageSupplier,
    AboutSupplier,
  },

  methods: {
    addSupplier() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editSupplier(supplier) {
      if (this.userType == 4) return
      this.currentSupplier = supplier
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteSupplier(supplier) {
      this.currentSupplier = supplier
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManySuppliers() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    openAbout(supplier) {
      this.currentSupplier = supplier
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.updateTable()
    },

    openImportDialog() {
      this.dialogKey = !this.dialogKey
      this.importDialog = true
    },

    openImportWindow() {
      this.$router.push({ name: 'supplier-import' })
    },

    closeImportDialog() {
      this.importDialog = false
      this.updateTable()
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.name = this.supplierName
      this.filter.corporateName = this.supplierCorporateName
      this.filter.cnpj = this.supplierCnpj
      this.filter.cpf = this.supplierCpf
      this.filter.technicalContact = this.supplierTechnicalContact
      this.filter.city = this.supplierCity
      this.filter.state = this.supplierState

      this.updateTable()
    },

    async getInstitutions() {
      this.institutionLoading = true
      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
      })
      this.institutionLoading = false
    },

    async updateTable() {
      this.loading = true

      this.filter.institutionId = this.institutionId
      this.filter.status =
        this.supplierStatus != null
          ? this.status.indexOf(this.supplierStatus)
          : 0

      await this.apiService
        .post('supplier/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.suppliers = response.content.suppliers
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.suppliers.length
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('supplier/delete', this.currentSupplier)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.updateTable()

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.deleteDialog = false
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('supplier/deleteMany', this.suppliersSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.updateTable()

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.suppliersSelected = []
    },

    async getStates() {
      this.statesLoading = true

      await this.apiService
        .get('address/states')
        .then((response) => {
          this.states = response.content.map((uf) => uf.sigla).sort()
          this.statesLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getCities() {
      this.citiesLoading = true

      await this.apiService
        .get(`address/cities?state=${this.supplierState}`)
        .then((response) => {
          this.cities = response.content.map((city) => city.nome).sort()
          this.citiesLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    reset() {
      this.supplierName = null
      this.supplierCorporateName = null
      this.supplierCnpj = null
      this.supplierCpf = null
      this.supplierTechnicalContact = null
      this.supplierCity = null
      this.supplierState = null
      this.supplierStatus = null
      this.cities = []
      this.filter = {
        page: 1,
        pageSize: 10,
        name: null,
        cnpj: null,
        cpf: null,
        corporateName: null,
        technicalContact: null,
        city: null,
        state: null,
        status: null,
      }
      this.updateTable()
      this.filterDialog = false
    },

    async exportToExcel() {
      this.loading = true

      try {
        const response = await this.apiService.post(
          'supplier/exportExcel',
          this.filter
        )

        let fileBase64 = response

        if (fileBase64 && typeof fileBase64 === 'string') {
          const byteCharacters = atob(fileBase64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'fornecedores.xlsx')
          document.body.appendChild(link)
          link.click()

          setTimeout(() => {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }, 100)

          this.loading = false
        } else {
          this.errorMessage = 'Nenhum fornecedor encontrado para exportação.'
          this.error = true
          this.loading = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        }
      } catch (error) {
        this.errorMessage = 'Erro ao exportar para Excel: ' + error.message
        this.error = true
        this.loading = false

        setTimeout(() => {
          this.error = false
        }, 4000)
      }
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    suppliersSelected() {
      this.buttonDeleteVisible = this.suppliersSelected.length > 0
    },
  },
}
</script>
